<section class="cmn-innerpage-wrapper invoice-new">
  <h2 class="cmn-inner-heading">
    {{
      isCancelling
        ? "Cancel Purchase Order"
        : purchaseOrderId
        ? "Update Purchase Order"
        : "New Purchase Order"
    }}
  </h2>
  <form [formGroup]="purchaseOrderForm" (keydown)="preventEnterKey($event)">
    <div class="invoice-new-form-wrapper">
      <div class="form-wrapper invoice-form-wrapper">
        <!-- Client Name Section -->
        <div class="cmn-Search-select-container">
          <label for="clientName">Vendor Name <span class="red">*</span></label>
          <mat-form-field>
            <mat-select
              placeholder="Search vendor"
              id="clientName"
              formControlName="vendorId"
              (selectionChange)="onVendorChange($event.value)"
            >
              <mat-option>
                <ngx-mat-select-search
                  [placeholderLabel]="'Search'"
                  [noEntriesFoundLabel]="'No options found'"
                  (input)="onVendorSearch($event)"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option
                *ngFor="let vendor of vendorsData"
                [value]="vendor.id"
              >
                {{ vendor?.vendorName }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  purchaseOrderForm.get('vendorId')!.touched &&
                  purchaseOrderForm.get('vendorId')!.hasError('required')
                "
                >*Vendor is required.</mat-error
              >
            </span>
          </div>
          <!-- <button (click)="openCreateVendorDialog()">
            <div>
              <img
                src="../../../assets/images/icons/icon-add-color.svg"
                alt="Add client"
              />
            </div>
            <span>Add vendor</span>
          </button> -->
        </div>

        <!-- New Purchase Order -->
        <div>
          <label for="purchaseOrderNo">
            Purchase Order No. <span class="red">*</span></label
          >
          <mat-form-field>
            <input
              matInput
              placeholder="Purchase order number"
              id="purchaseOrderNo"
              formControlName="purchaseOrderNo"
            />
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  purchaseOrderForm.get('purchaseOrderNo')!.touched &&
                  purchaseOrderForm.get('purchaseOrderNo')!.hasError('required')
                "
                >*Purchase order number is required.</mat-error
              >
            </span>
          </div>
        </div>

        <!-- Update Purchase Order -->
        <!-- <div *ngIf="!isCancelling && purchaseOrderId">
          <label for="oldPurchaseOrderNo">
            Purchase Order No.
            <span class="red">*</span></label
          >
          <mat-form-field>
            <input
              matInput
              placeholder="Purchase order number"
              id="oldPurchaseOrderNo"
              formControlName="oldPurchaseOrderNo"
              readonly
            />
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  purchaseOrderForm.get('oldPurchaseOrderNo')!.touched &&
                  purchaseOrderForm
                    .get('oldPurchaseOrderNo')!
                    .hasError('required')
                "
                >*Purchase order number is required.</mat-error
              >
            </span>
          </div>
        </div> -->

        <!-- Cancel Purchase Order -->
        <!-- <div *ngIf="isCancelling">
          <label for="purchaseOrderNo">
            Purchase Order No.
            <span class="red">*</span></label
          >
          <mat-form-field>
            <input
              matInput
              id="purchaseOrderNo"
              formControlName="purchaseOrderNo"
              readonly
            />
          </mat-form-field>
        </div> -->
        <div>
          <label for="trnNumber">TRN Number</label>
          <mat-form-field>
            <input
              matInput
              placeholder="TRN number"
              id="trnNumber"
              formControlName="trnNumber"
              [value]="selectedVendorTRN"
            />
          </mat-form-field>
        </div>

        <div>
          <label for="reference">Reference</label>
          <mat-form-field>
            <input
              matInput
              placeholder="Reference"
              id="reference"
              formControlName="reference"
            />
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  purchaseOrderForm.get('reference')!.touched &&
                  purchaseOrderForm.get('reference')!.hasError('maxlength')
                "
                >*Reference exceeds limit (max limit is 15)</mat-error
              >
            </span>
          </div>
        </div>

        <!-- <div *ngIf="isCancelling">
          <label for="oldPurchaseOrderNo">Reference (old PO number)</label>
          <mat-form-field>
            <input
              matInput
              id="oldPurchaseOrderNo"
              formControlName="oldPurchaseOrderNo"
              readonly
            />
          </mat-form-field>
        </div> -->
        <!-- <div class="cmn-Search-select-container">
          <label for="workorderId"
            >Work order number <span class="red">*</span></label
          >
          <mat-form-field>
            <mat-select
              placeholder="Search work order"
              id="workorderId"
              formControlName="workorderId"
              (selectionChange)="onWorkOrderChange($event.value)"
            >
            <mat-select-trigger>
              {{selectedWorkOrderDisplay}}
            </mat-select-trigger>
          
              <mat-option>
                <ngx-mat-select-search
                  [placeholderLabel]="'Search work order'"
                  [noEntriesFoundLabel]="'No options found'"
                  [formControl]="workOrderControl"
                >
                </ngx-mat-select-search>
              </mat-option>

              <mat-option
                *ngFor="let workorder of filteredWorkOrders"
                [value]="{
                  workOrderId: workorder?.id,
                  workOrderNo: workorder?.workOrderNo,
                  projectId: workorder?.projectData?.id,
                  projectName: workorder?.projectData?.projectName
                }"
              >
                {{ workorder?.workOrderNo }}-{{
                  workorder?.projectData?.projectName
                    ? workorder?.projectData?.projectName
                    : "NA"
                }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  purchaseOrderForm.get('workorderId')!.touched &&
                  purchaseOrderForm.get('workorderId')!.hasError('required')
                "
                >*Work order number is required.</mat-error
              >
            </span>
          </div>
        </div> -->
        <!-- <div class="cmn-Search-select-container">
          <label for="workorderId">Work order number <span class="red">*</span></label>
          <mat-form-field>
            <mat-select
              placeholder="Search work order"
              id="workorderId"
              formControlName="workorderId"
              (selectionChange)="onWorkOrderChange($event.value)"
              [compareWith]="compareWorkOrders"
            >
              <mat-select-trigger>
                {{ selectedWorkOrderDisplay || 'Search work order' }}
              </mat-select-trigger>
        
              <mat-option>
                <ngx-mat-select-search
                  [placeholderLabel]="'Search work order'"
                  [noEntriesFoundLabel]="'No options found'"
                  [formControl]="workOrderControl"
                >
                </ngx-mat-select-search>
              </mat-option>
        
              <mat-option
                *ngFor="let workorder of filteredWorkOrders"
                [value]="{
                  workOrderId: workorder?.id,
                  workOrderNo: workorder?.workOrderNo,
                  projectId: workorder?.projectData?.id,
                  projectName: workorder?.projectData?.projectName
                }"
              >
                {{ workorder?.workOrderNo }} - {{ workorder?.projectData?.projectName || 'NA' }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="purchaseOrderForm.get('workorderId')?.touched &&
                       purchaseOrderForm.get('workorderId')?.hasError('required')"
              >
                *Work order number is required.
              </mat-error>
            </span>
          </div>
        </div> -->
        
        <div>
          <label for="currency">Currency <span class="red">*</span></label>
          <mat-form-field>
            <mat-select
              placeholder="Select currency"
              id="currency"
              formControlName="currency"
              [disabled]="true"
            >
              <mat-option
                *ngFor="let currency of allCurrencies"
                [value]="currency.id"
                >{{ currency?.currencyCode }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  purchaseOrderForm.get('currency')!.touched &&
                  purchaseOrderForm.get('currency')!.hasError('required')
                "
                >Currency is required.</mat-error
              >
            </span>
          </div>
        </div>
        <!-- Due Date Section -->
        <div>
          <label for="date">Bill Date <span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              placeholder="Select date"
              formControlName="billDate"
              readonly
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="currentDatePicker"
              disabled
            ></mat-datepicker-toggle>
            <mat-datepicker #currentDatePicker></mat-datepicker>
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  purchaseOrderForm.get('billDate')!.touched &&
                  purchaseOrderForm.get('billDate')!.hasError('required')
                "
                >*Date is required.</mat-error
              >
            </span>
          </div>
        </div>
        <!-- <div>
          <label for="shipmentPreference">Shipment Preference</label>
          <mat-form-field>
            <input
              matInput
              placeholder="Shipment preference"
              id="shipmentPreference"
              formControlName="shipmentPreference"
            />
          </mat-form-field>
        </div>

        <div>
          <label for="paymentTerms"
            >Payment Terms <span class="red">*</span></label
          >
          <mat-form-field appearance="fill">
            <textarea
              matInput
              placeholder="Enter payment terms"
              id="paymentTerms"
              formControlName="paymentTerms"
              rows="3"
            ></textarea>
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  purchaseOrderForm.get('paymentTerms')!.touched &&
                  purchaseOrderForm.get('paymentTerms')!.hasError('required')
                "
                >*Payment terms is required.</mat-error
              >
            </span>
          </div>
        </div> -->
      </div>
      <br />
      <br />
      <div>
        <label for="deliveryAddress"><strong>Delivery Address</strong></label>

        <div class="service-address-wrapper">
          <!-- <div class="type-selection">
            <label class="radiobtn-wrapper">
              <input
                type="radio"
                name="address"
                (click)="toggleOrgainization()"
                [checked]="!isCustomerSelected"
              />
              <span class="radiomark"></span>
              Organization
            </label>
            <label class="radiobtn-wrapper">
              <input
                type="radio"
                name="address"
                (click)="toggleCustomer()"
                [checked]="isCustomerSelected"
              />
              <span class="radiomark"></span>
              Customer
            </label>
          </div> -->

          <!-- Customer List -->
          <!-- <div
            class="form-wrapper invoice-form-wrapper"
            *ngIf="isCustomerSelected === true"
          >
            <div class="cmn-Search-select-container">
              <mat-form-field>
                <mat-select
                  placeholder="Search customer"
                  id="clientName"
                  formControlName="customerId"
                  (selectionChange)="onCustomerChange($event)"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [placeholderLabel]="'Search'"
                      [noEntriesFoundLabel]="'No options found'"
                      [formControl]="customerControl"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let customer of cutomersData"
                    [value]="customer.id"
                  >
                    {{ customer.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div> -->

          <div class="billing-shipping-address-wrapper">
            <div>
              <div class="header-wrapper">
                <h5>Billing Address <span class="red">*</span></h5>
                <!-- <div (click)="openSelectBillingAddressDialog()">
                  <img
                    src="/assets/images/icons/icon-edit-accounts.svg"
                    alt=""
                  />
                </div> -->
              </div>
              <div *ngIf="selectedAddress.length>0">
                <h6>{{ selectedAddress }}</h6>
                <!-- <ul>
                  <li>{{ selectedAddress?.addressLine1 }}</li>
                  <li>{{ selectedAddress?.city }}</li>
                  <li>{{ selectedAddress?.state }}</li>
                  <li>{{ selectedAddress?.country }}</li>
                  <li>{{ selectedAddress?.phone }}</li>
                  <li>{{ selectedAddress?.fax }}</li>
                </ul> -->
                <!-- <input
                  type="hidden"
                  formControlName="billingAddressId"
                  [value]="selectedBillingAddress?.id"
                />
                <button (click)="openBillingAddressDialog('add')">
                  <span>Add Address</span>
                </button> -->
              </div>
            </div>
            <div>
              <div class="header-wrapper">
                <h5>Shipping Address <span class="red">*</span></h5>
                <!-- <div (click)="openSelectShippingAddressDialog()">
                  <img
                    src="/assets/images/icons/icon-edit-accounts.svg"
                    alt=""
                  />
                </div> -->
              </div>
              <div *ngIf="selectedAddress.length>0">
                <h6>{{ selectedAddress }}</h6>
                <!-- <ul>
                  <li>{{ selectedAddress?.addressLine1 }}</li>
                  <li>{{ selectedAddress?.city }}</li>
                  <li>{{ selectedAddress?.state }}</li>
                  <li>{{ selectedAddress?.country }}</li>
                  <li>{{ selectedAddress?.phone }}</li>
                  <li>{{ selectedAddress?.fax }}</li>
                </ul> -->
                <!-- <input
                  type="hidden"
                  formControlName="shippingAddressId"
                  [value]="selectedShippingAddress?.id"
                />
                <button (click)="openShippingAddressDialog('add')">
                  <span>Add Address</span>
                </button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="form-wrapper">
        <label for="subject">Subject</label>
        <mat-form-field>
          <textarea
            matInput
            placeholder="Enter Subject"
            id="subject"
            formControlName="subject"
          ></textarea>
        </mat-form-field>
      </div> -->
    </div>

    <!-- <div
      class="quotation-table-container"
      *ngIf="newPurchaseItems && newPurchaseItems.length > 0"
    >
      <div>
        <table>
          <thead>
            <tr>
              <th>SL No.</th>
              <th>Description</th>
              <th>Unit</th>
              <th>QTY</th>
              <th>Rate</th>
              <th>Adjusted</th>
              <th>Gross Price</th>
              <th>Discount</th>
              <th>Net Price</th>
              <th>Adjusted</th>
              <th>VAT</th>
              <th>Amount</th>
              <th>Subject</th>
              <th>Action</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let item of newPurchaseItems; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ item?.itemName }}</td>
              <td>{{ item?.unit }}</td>
              <td>{{ item?.quantity }}</td>
              <td>{{ item?.rate }}</td>
              <td>{{ item?.rate.toFixed(2) }}</td>
              <td>{{ (item?.rate * item?.quantity)?.toFixed(2) }}</td>
              <td>{{ purchaseOrderData?.discount ? purchaseOrderData?.discount : 0.0 }}</td>
              <td>
                {{
                  (item?.rate * item?.quantity - purchaseOrderData?.discount)?.toFixed(
                    2
                  )
                }}
              </td>
              <td>
                {{ (item?.rate * item?.quantity - purchaseOrderData?.discount)?.toFixed(2) }}
              </td>
              <td>{{ item?.tax?.toFixed(2) }}</td>
              <td>
                {{
                  (
                    item?.rate * item?.quantity -
                    purchaseOrderData?.discount +
                    item?.tax
                  )?.toFixed(2)
                }}
              </td>
              <td>{{ item.itemId ? item?.subjectList : item?.subject }}</td>
              <td>
                <img
                  src="assets/images/icons/icon-delete.svg"
                  alt="Delete Item"
                  style="text-align: left"
                  (click)="removeNewPurchaseItem(i)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> -->

    <div class="item-service-adding-table-wrapper" formArrayName="items">
      <table>
        <thead>
          <tr>
            <th>Item Name <span class="red">*</span></th>
            <th>Description</th>
            <th>Quantity <span class="red">*</span></th>
            <th>Unit Price<span class="red">*</span></th>
            <th>Sub Total</th>
            <th>VAT(5%)</th>
            <th>Total Amount</th>
          </tr>
        </thead>

        <tbody>
          <tr
            *ngFor="let item of items.controls; let i = index"
            [formGroupName]="i"
          >
            <!-- Item description data -->
            <td>
              <div class="form-wrapper">
                <div>
                  <mat-form-field>
                    <input
                      matInput
                      placeholder="Item Name"
                      formControlName="itemName"
                    />
                  </mat-form-field>
                  <div
                    class="custom-error"
                    *ngIf="item.get('itemName')?.touched"
                  >
                    <span>
                      <mat-error
                        *ngIf="item.get('itemName')?.errors?.['required']"
                      >
                        Item is required.
                      </mat-error>
                    </span>
                  </div>
                </div>
              </div>
            </td>

            <!-- Description  -->
            <td>
              <div class="form-wrapper">
                <div>
                  <mat-form-field>
                    <input
                      matInput
                      placeholder="Description"
                      formControlName="description"
                    />
                  </mat-form-field>
                </div>
              </div>
            </td>
            <!-- Quanitity data -->
            <td>
              <div class="form-wrapper">
                <mat-form-field>
                  <input
                    matInput
                    placeholder="Quantity"
                    formControlName="quantity"
                    (keypress)="allowOnlyInteger($event)"
                    (paste)="blockPasteNonInteger($event)"
                  />
                </mat-form-field>
                <div class="custom-error">
                  <span>
                    <mat-error
                      *ngIf="
                        item.get('quantity')?.touched &&
                        item.get('quantity')?.hasError('required')
                      "
                      >Quantity is required.</mat-error
                    >
                  </span>
                  <span>
                    <mat-error
                      *ngIf="item.get('quantity')?.hasError('nonNegative')"
                      >Quantity must be greater than 0.</mat-error
                    >
                  </span>
                </div>
              </div>
            </td>
            <!-- Rate data -->
            <td>
              <div class="form-wrapper">
                <mat-form-field>
                  <input
                    matInput
                    placeholder="Unit price"
                    formControlName="rate"
                    (keypress)="allowOnlyNumberWithDecimal($event)"
                    (paste)="blockPaste($event)"
                  />
                </mat-form-field>
                <div class="custom-error">
                  <span>
                    <mat-error
                      *ngIf="
                        item.get('rate')?.touched &&
                        item.get('rate')?.hasError('required')
                      "
                      >Unit price is required.</mat-error
                    >
                  </span>
                  <span>
                    <mat-error *ngIf="item.get('rate')?.hasError('nonNegative')"
                      >Unit price cannot be negative.</mat-error
                    >
                  </span>
                </div>
              </div>
            </td>

            <td>
              <div class="form-wrapper">
                <mat-form-field>
                  <input
                    matInput
                    placeholder="Sub Total"
                    formControlName="subTotal"
                    readonly
                  />
                </mat-form-field>
                <div class="custom-error">
                  <span>
                    <mat-error
                      *ngIf="
                        item.get('subTotal')?.touched &&
                        item.get('subTotal')?.hasError('required')
                      "
                      >Sub Total is required.</mat-error
                    >
                  </span>
                  <span>
                    <mat-error
                      *ngIf="item.get('subTotal')?.hasError('nonNegative')"
                      >Sub Total cannot be negative.</mat-error
                    >
                  </span>
                </div>
              </div>
            </td>

            <!-- Vat tax Data -->
            <td>
              <div class="form-wrapper">
                <mat-form-field>
                  <input
                    matInput
                    placeholder="VAT"
                    formControlName="tax"
                    type="number"
                    readonly
                  />
                </mat-form-field>
                <div class="custom-error">
                  <span>
                    <mat-error
                      *ngIf="
                        item.get('tax')?.touched &&
                        item.get('tax')?.hasError('required')
                      "
                      >VAT is required.</mat-error
                    >
                  </span>
                  <span>
                    <mat-error *ngIf="item.get('tax')?.hasError('nonNegative')"
                      >VAT cannot be negative.</mat-error
                    >
                  </span>
                </div>
              </div>
            </td>
            <!-- Total amount data -->
            <td>
              <div class="form-wrapper">
                <mat-form-field>
                  <input
                    matInput
                    placeholder="Total Amount"
                    formControlName="totalAmount"
                    type="number"
                    readonly
                  />
                </mat-form-field>
                <div class="custom-error">
                  <span>
                    <mat-error
                      *ngIf="
                        item.get('totalAmount')?.touched &&
                        item.get('totalAmount')?.hasError('required')
                      "
                    >
                      Amount is required.
                    </mat-error>
                  </span>
                </div>
              </div>
              <span class="delete">
                <img
                  src="../../../assets/images/icons/icon-close.svg"
                  alt="Delete"
                  (click)="onRemoveNewlyAddedItems(i)"
                />
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <button type="button" (click)="addItem()">
        <img src="../../../assets/images/icons/icon-add-color.svg" alt="Add" />
        Add
      </button>
    </div>

    <div class="notes-tatal-amount-container">
      <div>
        <!-- <div class="form-container">
          <div class="form-wrapper">
            <label for="customerNotes">Terms And Conditions</label>
            <mat-form-field>
              <textarea
                matInput
                placeholder="Enter your notes here..."
                formControlName="customerNotes"
              ></textarea>
            </mat-form-field>
          </div>
        </div> -->

        <!-- ADDITIONAL DISCOUNT -->
        <div class="form-container">
          <div class="form-wrapper">
            <label>Additional Discount</label>
            <mat-form-field>
              <mat-label>Additional Discount</mat-label>
              <input
                matInput
                type="number"
                formControlName="additionalDiscount"
                (blur)="calculateLogic()"
              />
            </mat-form-field>
            <div class="custom-error">
              <span>
                <mat-error
                  *ngIf="
                    purchaseOrderForm.get('additionalDiscount')!.touched &&
                    purchaseOrderForm
                      .get('additionalDiscount')!
                      .hasError('additionalDiscountInvalid')
                  "
                >
                  Additional discount must be less than or equal to Grand Total
                </mat-error>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="amount-table-div">
        <div>
          <h6>
            Total Amount
            <span
              >: {{ selectedCurrencyCode }}
              {{ subTotal.toFixed(2) | number : "1.2-2" }}</span
            >
          </h6>
          <h6>
            Discount (-)
            <span
              >: {{ selectedCurrencyCode }}
              {{ totalDiscount | number : "1.2-2" }}</span
            >
          </h6>
          <h6>
            Additional Discount (-)
            <span
              >: {{ selectedCurrencyCode }}
              {{ additionalDiscount | number : "1.2-2" }}</span
            >
          </h6>
          <h6>
            VAT (5%)
            <span
              >: {{ selectedCurrencyCode }}
              {{ totalVat.toFixed(2) | number : "1.2-2" }}</span
            >
          </h6>
        </div>
        <div>
          <h4>
            Grand Total
            <span
              >: {{ selectedCurrencyCode }}
              {{ grandTotal.toFixed(2) | number : "1.2-2" }}</span
            >
          </h4>
        </div>
      </div>
    </div>

    <div class="submit-btn-wrapper">
      <button class="cmn-cancel-btn" type="button" (click)="onCancel()">
        Cancel
      </button>
      <button
        class="cmn-draft-btn"
        [disabled]="loading"
        type="button"
        (click)="saveAsDraft()"
        *ngIf="!isCancelling"
      >
        <span *ngIf="!loading">Save As Draft</span>
        <span *ngIf="loading">Loading...</span>
      </button>
      <!-- <button class="cmn-next-btn" type="submit">Save and Send</button> -->
      <button
        class="cmn-next-btn"
        type="button"
        (click)="saveAndSend()"
        [disabled]="loading"
        *ngIf="!isCancelling"
      >
        <span *ngIf="!loading">Save as Open</span>
        <span *ngIf="loading">Loading...</span>
      </button>

      <button
        class="cmn-next-btn"
        type="button"
        *ngIf="isCancelling"
        (click)="saveAndSend()"
      >
        <span *ngIf="!loading">Cancel and Create</span>
        <span *ngIf="loading">Loading...</span>
      </button>
    </div>
  </form>
</section>
